import { render, staticRenderFns } from "./VirtualShopEmpty.vue?vue&type=template&id=e31e8b92&scoped=true"
import script from "./VirtualShopEmpty.vue?vue&type=script&lang=ts"
export * from "./VirtualShopEmpty.vue?vue&type=script&lang=ts"
import style0 from "./VirtualShopEmpty.vue?vue&type=style&index=0&id=e31e8b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31e8b92",
  null
  
)

export default component.exports